import { ConfigItem } from 'Core/interfaces'
import { DefaultFile } from 'Core/interfaces'

export enum RepublicInvoiceSearchResultFields {
	searchResultById = 'searchResultById',
	searchResultBySupplierLocationId = 'searchResultBySupplierLocationId',
	searchResultBySupplierLocationName = 'searchResultBySupplierLocationName',
	searchResultBySupplierInvoiceNumber = 'searchResultBySupplierInvoiceNumber'
}

export enum RepublicInvoiceFilterFields {
	supplierInvoiceDateFrom = 'invoiceDate',
	statusCode = 'statusCode',
	includeComplete = 'includeComplete'
}

export enum RepublicInvoiceLabels {
	Id = 'id',
	SupplierLocation = 'supplierLocation',
	SupplierInvoiceNumber = 'supplierInvoiceNumber',
	SupplierInvoiceDate = 'supplierInvoiceDate',
	TotalInvoiceAmount = 'totalInvoiceAmount',
	MappedItemAmount = 'mappedItemAmount',
	FileName = 'fileName',
	Status = 'status',
	CreatedBy = 'createdBy',
	CreateDate = 'createDate',
	LastUpdatedBy = 'lastUpdatedBy',
	LastUpdateDate = 'lastUpdateDate',
	SupplierLocationId = 'supplierLocationId',
	Document = 'document',
	Item = 'item',
	TotalAmount = 'totalAmount',
	ContainerSize = 'containerSize',
	ContainerType = 'containerType',
	ItemDescription = 'itemDescription',
	InvoiceAccount = 'invoiceAccount',
	ServiceSite = 'serviceSite',
	ServiceDate = 'serviceDate',
	Haul = 'haul',
	Tonnage = 'tonnage',
	Bol = 'bol',
	UnitOfMeasure = 'unitOfMeasure',
	Cost = 'cost',
	DefaultItems = 'defaultItems',
	DependedItems = 'dependedItems',
	CostAndUnitOfMeasure = 'costAndUnitOfMeasure',
	Weight = 'weight',
	ChargeTypeCode = 'chargeTypeCode',
	IncludeComplete = 'includeComplete'
}

export declare namespace RepublicInvoice {
	interface Basic {
		[RepublicInvoiceLabels.Id]: Key
		[RepublicInvoiceLabels.SupplierLocation]: Entity
		[RepublicInvoiceLabels.SupplierInvoiceNumber]: string
		[RepublicInvoiceLabels.SupplierInvoiceDate]: string | null
		[RepublicInvoiceLabels.TotalInvoiceAmount]: number
		[RepublicInvoiceLabels.MappedItemAmount]: number
		[RepublicInvoiceLabels.FileName]: string
		[RepublicInvoiceLabels.Status]: NameCode
		[RepublicInvoiceLabels.CreatedBy]: string
		[RepublicInvoiceLabels.CreateDate]: string
		[RepublicInvoiceLabels.LastUpdatedBy]: string
		[RepublicInvoiceLabels.LastUpdateDate]: string
	}

	interface Form {
		[RepublicInvoiceLabels.SupplierLocationId]: number
		[RepublicInvoiceLabels.Document]: DefaultFile | null
	}

	interface Request {
		[RepublicInvoiceLabels.SupplierLocationId]: number
		[RepublicInvoiceLabels.Document]: File | null
	}

	interface InvoiceItem extends Entity {
		[RepublicInvoiceLabels.UnitOfMeasure]: Entity | null
		[RepublicInvoiceLabels.Cost]: BasicNumber
		[RepublicInvoiceLabels.ChargeTypeCode]: NullableEntity
	}

	namespace InvoiceLoad {
		interface Basic {
			[RepublicInvoiceLabels.Id]: Key
			[RepublicInvoiceLabels.Item]: InvoiceItem
			[RepublicInvoiceLabels.TotalAmount]: number
			[RepublicInvoiceLabels.ContainerSize]: string
			[RepublicInvoiceLabels.ContainerType]: string
			[RepublicInvoiceLabels.ItemDescription]: string
			[RepublicInvoiceLabels.InvoiceAccount]: string
			[RepublicInvoiceLabels.ServiceSite]: Entity | null
			[RepublicInvoiceLabels.ServiceDate]: string
			[RepublicInvoiceLabels.Haul]: number
			[RepublicInvoiceLabels.Tonnage]: number
			[RepublicInvoiceLabels.Bol]: string
			[RepublicInvoiceLabels.UnitOfMeasure]: Entity | null
			[RepublicInvoiceLabels.Cost]: BasicNumber
			[RepublicInvoiceLabels.DefaultItems]: InvoiceItem[]
			[RepublicInvoiceLabels.DependedItems]: InvoiceItem[]
			[RepublicInvoiceLabels.Weight]: number | null
			[RepublicInvoiceLabels.ChargeTypeCode]: NullableEntity
		}

		interface Form {
			[RepublicInvoiceLabels.Item]: LabelValue<number> | null
			[RepublicInvoiceLabels.Weight]?: Key | null
		}

		interface Request {
			itemId: number | null
			weight?: number | null
		}
	}

	interface ItemMapping extends Entity {
		[RepublicInvoiceLabels.CostAndUnitOfMeasure]: number
	}

	namespace Search {
		interface Config {
			[RepublicInvoiceSearchResultFields.searchResultById]: ConfigItem<RepublicInvoiceSearchResultFields>
			[RepublicInvoiceSearchResultFields.searchResultBySupplierLocationId]: ConfigItem<RepublicInvoiceSearchResultFields>
			[RepublicInvoiceSearchResultFields.searchResultBySupplierLocationName]: ConfigItem<RepublicInvoiceSearchResultFields>
			[RepublicInvoiceSearchResultFields.searchResultBySupplierInvoiceNumber]: ConfigItem<RepublicInvoiceSearchResultFields>
		}
		interface Result {
			[RepublicInvoiceSearchResultFields.searchResultById]: Entity[]
			[RepublicInvoiceSearchResultFields.searchResultBySupplierLocationId]: Entity[]
			[RepublicInvoiceSearchResultFields.searchResultBySupplierLocationName]: Entity[]
			[RepublicInvoiceSearchResultFields.searchResultBySupplierInvoiceNumber]: Entity[]
		}
	}
}
